import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { locations } from '../data/mockData';
import '../styles/LocationsSection.css';

const LocationsSection = () => {
  return (
    <section id="locations" className="locations-section">
      <div className="locations-container">
        <div className="section-header">
          <div className="section-label">Visit Us</div>
          <h2 className="section-title">Practice Locations</h2>
        </div>
        
        <div className="locations-grid">
          {locations.map((location, index) => (
            <div key={index} className="location-card">
              <div className="location-image-wrapper">
                <img src={location.mapUrl} alt={location.name} className="location-image" />
                <div className="location-overlay"></div>
              </div>
              
              <div className="location-content">
                <h3 className="location-name">{location.name}</h3>
                
                <div className="location-details">
                  <div className="location-detail">
                    <MapPin size={18} />
                    <span>{location.address}</span>
                  </div>
                  
                  <div className="location-detail">
                    <Phone size={18} />
                    <a href={`tel:${location.phone}`}>{location.phone}</a>
                  </div>
                  
                  <div className="location-detail">
                    <Mail size={18} />
                    <a href={`mailto:${location.email}`}>{location.email}</a>
                  </div>
                </div>
                
                <div className="location-timings">
                  <div className="timings-header">
                    <Clock size={18} />
                    <span>Consultation Hours</span>
                  </div>
                  {location.timings.map((timing, idx) => (
                    <div key={idx} className="timing-row">
                      <span className="timing-days">{timing.days}</span>
                      <span className="timing-hours">{timing.hours}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;
